import { render, staticRenderFns } from "./DocumentoIndex.vue?vue&type=template&id=66a77a37"
import script from "./DocumentoIndex.vue?vue&type=script&lang=js"
export * from "./DocumentoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports